import jsonQuestions from "../questions.json";

export const profilePath = jsonQuestions.data.section.profileCreateQuestions;
export const boothPath = jsonQuestions.data.section.boothSurveyQuestions;

// export const languagePath = () =>{

// }